<template>
  <div class="modal-overlay" @click="$emit('close')">
    <div class="modal-content feedback-modal" @click.stop>
      <button class="modal-close" @click="$emit('close')">×</button>
      <h2>💡 Feedback & Suggestions</h2>
      
      <div class="feedback-content">
        <p class="feedback-intro">We'd love to hear from you! Join our community on Reddit.</p>
        
        <div class="feedback-option">
          <div class="option-icon">💬</div>
          <div class="option-content">
            <h3>Share Your Feedback</h3>
            <p>Post your suggestions, bug reports, or general feedback</p>
            <a 
              href="https://www.reddit.com/r/myKaraokeWorld/" 
              target="_blank" 
              rel="noopener noreferrer"
              class="reddit-button"
              @click="handleRedditClick('general')"
            >
              Visit r/myKaraokeWorld
            </a>
          </div>
        </div>

        <div class="feedback-option">
          <div class="option-icon">✨</div>
          <div class="option-content">
            <h3>Browse Feature Requests</h3>
            <p>See what others are suggesting and upvote your favorites</p>
            <a 
              href="https://www.reddit.com/r/myKaraokeWorld/?f=flair_name%3A%22Feature%20Request%22" 
              target="_blank" 
              rel="noopener noreferrer"
              class="reddit-button secondary"
              @click="handleRedditClick('feature_requests')"
            >
              View Feature Requests
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useAnalytics } from '../composables/useAnalytics'

export default {
  name: 'FeedbackButton',
  emits: ['close'],
  props: {
    roomId: {
      type: String,
      required: true
    }
  },
  setup() {
    const { trackEvent } = useAnalytics()
    return { trackEvent }
  },
  methods: {
    handleRedditClick(type) {
      this.trackEvent('reddit_link_clicked', {
        room_id: this.roomId,
        link_type: type
      });
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
}

.modal-content {
  background: #1a1a1a;
  border-radius: 12px;
  padding: 2rem;
  max-width: 500px;
  width: 90%;
  position: relative;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.feedback-modal {
  max-width: 450px;
}

.modal-close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.5);
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.5rem;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s;
}

.modal-close:hover {
  background: rgba(255, 255, 255, 0.1);
  color: white;
}

.modal-content h2 {
  color: #ffa500;
  margin: 0 0 1rem;
  font-size: 1.5rem;
  font-weight: 500;
}

.feedback-intro {
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.95rem;
  margin-bottom: 1.5rem;
  line-height: 1.5;
}

.feedback-content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.feedback-option {
  display: flex;
  gap: 1rem;
  padding: 1.25rem;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.2s;
}

.feedback-option:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 165, 0, 0.3);
}

.option-icon {
  font-size: 2rem;
  flex-shrink: 0;
}

.option-content {
  flex: 1;
}

.option-content h3 {
  color: white;
  font-size: 1.1rem;
  margin: 0 0 0.5rem;
  font-weight: 500;
}

.option-content p {
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.875rem;
  margin: 0 0 1rem;
  line-height: 1.4;
}

.reddit-button {
  display: inline-block;
  padding: 0.6rem 1.2rem;
  background: #FF4500;
  color: white;
  text-decoration: none;
  border-radius: 6px;
  font-size: 0.9rem;
  font-weight: 500;
  transition: all 0.2s;
}

.reddit-button:hover {
  background: #ff5722;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(255, 69, 0, 0.4);
}

.reddit-button.secondary {
  background: rgba(255, 165, 0, 0.2);
  border: 1px solid #ffa500;
  color: #ffa500;
}

.reddit-button.secondary:hover {
  background: rgba(255, 165, 0, 0.3);
  border-color: #ff9500;
  color: #ff9500;
  box-shadow: 0 4px 12px rgba(255, 165, 0, 0.3);
}

@media (max-width: 480px) {
  .modal-content {
    padding: 1.5rem;
  }
  
  .feedback-option {
    flex-direction: column;
    text-align: center;
  }
  
  .option-icon {
    font-size: 2.5rem;
  }
}
</style> 